// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"0855ca37","362":"c12b4692","386":"9d4c2dc3","402":"44959c75","413":"d84dc46c","494":"87a7d149","505":"1df0e70e","605":"87a7d149","615":"25e09829","858":"f9ef327a","900":"339be791","919":"0855ca37"}[chunkId] + ".chunk.css";
};